import {
    Box,
    useMediaQuery,
    useTheme
} from '@mui/material';
import HeroTitle from './heroTitle';
import HeroCharacter from './heroCharacter';
import Particles from '../../../components/effects/particles/particles'

const HeroLayout = () => {
    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <>
            <Box
                className="bodyPadding navigationSpace"
                sx={{
                    backgroundColor: theme.palette.primary.main,
                }}
            >
                <div 
                    style={{ 
                        width: '90%', 
                        height: isMobile ? '200px' : '500px', 
                        position: 'absolute',
                        zIndex: 1,
                        top: 100,
                        display: 'flex',
                        overflow: 'hidden'
                    }}
                >
                    <Particles
                        particleColors={['#ffffff', '#ffffff']}
                        particleCount={isMobile ? 100 : 250}
                        particleSpread={10}
                        speed={0.1}
                        particleBaseSize={100}
                        moveParticlesOnHover={false}
                        alphaParticles={false}
                        disableRotation={false}
                    />
                </div>
                
                <HeroTitle />

                <HeroCharacter />
            </Box>
        </>
    );
}

export default HeroLayout;